import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import { Quote } from "lucide-react";
import "swiper/css";
import "swiper/css/pagination";

import SectionHeading from "./SectionHeading";
import { testimonials } from "../data/site";

export default function TestimonialsSection() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-28 md:py-40 px-6 md:px-12 bg-[#0c0c0f]"
    >
      <div className="absolute -left-20 top-1/3 h-[400px] w-[400px] orange-glow opacity-40" />
      <div className="relative max-w-5xl mx-auto">
        <SectionHeading
          eyebrow="Voices of partners"
          title="Calm. Technical. Dependable."
          align="center"
          testId="testimonials-heading"
        />

        <div className="mt-16">
          <Swiper
            modules={[Autoplay, Pagination]}
            spaceBetween={32}
            slidesPerView={1}
            loop
            autoplay={{ delay: 6000, disableOnInteraction: false }}
            pagination={{ clickable: true }}
            className="!pb-14"
          >
            {testimonials.map((t, i) => (
              <SwiperSlide key={i}>
                <div
                  data-testid={`testimonial-slide-${i}`}
                  className="glass rounded-2xl p-10 md:p-14 text-center"
                >
                  <Quote className="mx-auto text-[#C96A2B]" size={36} />
                  <p className="font-display text-2xl md:text-3xl leading-snug mt-8">
                    “{t.quote}”
                  </p>
                  <div className="mt-10 divider-line max-w-[120px] mx-auto" />
                  <p className="mt-6 font-display text-lg">{t.name}</p>
                  <p className="text-xs tracking-[0.2em] uppercase text-white/45 mt-1">
                    {t.company}
                  </p>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style>{`
        .swiper-pagination-bullet { background: rgba(255,255,255,0.25); opacity:1; }
        .swiper-pagination-bullet-active { background: #C96A2B; width:24px; border-radius:4px; transition:width .3s;}
      `}</style>
    </section>
  );
}
